import React from 'react';
import { LoginLayout, mobileAppAvailableCountries } from './LoginLayout';
import { ForgotPassword } from './forgot-password/ForgotPassword';
import { useSiteConfig } from '../config';
import { ImThemeProviderZenith } from '@im/im-theme';
import { MuiProviders } from '@im/ui-lib/theme/MuiProviders';
import { useTranslate } from '@im/react-localization';
import { LoginView } from './LoginView';

export const ForgotPasswordView = () => {
  const { siteCode } = useSiteConfig();
  const zenithEnabled = mobileAppAvailableCountries.includes(
    siteCode?.toLowerCase()
  );

  const translate = useTranslate();

  return zenithEnabled ? (
    <ImThemeProviderZenith>
      <MuiProviders>
        <LoginView primaryAuthTitle={translate('Login.ForgotPasswordHeader')}>
          <ForgotPassword zenith={zenithEnabled} />
        </LoginView>
      </MuiProviders>
    </ImThemeProviderZenith>
  ) : (
    <LoginLayout>
      <ForgotPassword />
    </LoginLayout>
  );
};
